import lodash from 'lodash';

import { ACTIONS } from '../actions/leader-board';

const initState = {
    customReports: [],
    tableList: {
        size: 0,
        key: {},
        headers: [],
        list: [],
        loading: false,
        error: null,
        hasTotal: null,
    },
    years: [],
    reports: {
        player: {
            pitcher: [],
            batter: [],
        },
        team: {
            pitcher: [],
            batter: [],
        },
    },
    teams: [],
    columns: [],
    filters: [],
    error: null,
};
export default (state = lodash.cloneDeep(initState), action) => {
    switch (action.type) {
        case ACTIONS.GET_CUSTOME_LEADER_BOARD_SUCCESS:
            return {
                ...state,
                customReports: action.data
            }
        case ACTIONS.GET_YEAR_LEADER_BOARD_SUCCESS:
            return {
                ...state,
                years: action.data
            }
        case ACTIONS.GET_REPORTS_LEADER_BOARD_SUCCESS:
            return {
                ...state,
                reports: action.data
            }
        case ACTIONS.GET_ALL_TEAM_LEADER_BOARD_SUCCESS:
            return {
                ...state,
                teams: [
                    { id: 'central_league', ids: lodash.map(action.data.central_league, 'id'), team_name: 'セ・リーグ' },
                    { id: 'pacific_league', ids: lodash.map(action.data.pacific_league, 'id'), team_name: 'パ・リーグ' },
                    ...action.data.central_league.map((item => {
                        return { ...item, team_name: item.team_name_s, type: 'central_league', ids: [item.id] }
                    })), ...action.data.pacific_league.map((item) => {
                        return { ...item, team_name: item.team_name_s, type: 'pacific_league', ids: [item.id] }
                    })
                ]
            }
        case ACTIONS.RESET_CONTENT_TABLE:
            return {
                ...state,
                tableList: lodash.cloneDeep(initState.tableList),
            }
        case ACTIONS.GET_CONTENT_TABLE_LOADING:
            return {
                ...state,
                tableList: {
                    ...lodash.cloneDeep(initState.tableList),
                    loading: true,
                },
            }
        case ACTIONS.SORT_CONTENT_TABLE:
            return {
                ...state,
                tableList: {
                    ...lodash.cloneDeep(state.tableList),
                    list: lodash.orderBy(state.tableList.list, action.field, action.order)
                }
            }
        case ACTIONS.GET_CONTENT_TABLE_SUCCESS:
            const updatedDateText = action.data.updated_date_text ?? (() => {
                let latest = null;
                for (const row of action.data.data) {
                    for (const datumGroup of row.data) {
                        for (const datum of datumGroup) {
                            if (datum.column === "updated_datetime") {
                                const cleanedValue = datum.value.replace(/\.\d+$/, ''); // 小数点以下を削除
                                const current = new Date(cleanedValue);
                                if (!latest || current > latest) {
                                    latest = current;
                                }
                            }
                        }
                    }
                }

                if (!latest) return "";
                // 日本語形式：YYYY年M月D日終了時点のデータ
                const year = latest.getFullYear();
                const month = latest.getMonth() + 1;
                const day = latest.getDate();

                return `※${year}年${month}月${day}日終了時点のデータ`;
            })();

            // "updated_datetime" を data から削除したバージョンを作成
            const cleanedData = action.data.data.map(row => ({
                ...row,
                data: row.data.map(datumGroup =>
                    datumGroup.filter(datum => datum.column !== "updated_datetime")
                )
            }));

            return {
                ...state,
                tableList: {
                    size: action.data.size,
                    key: action.data.key,
                    headers: action.data.columns.filter(item => item.column !== "updated_datetime"),
                    loading: false,
                    list: cleanedData,
                    hasTotal: action.data.hasTotal,
                    updatedDateText: updatedDateText,
                }
            }
        case ACTIONS.GET_CONTENT_TABLE_ERROR:
            return {
                ...state,
                tableList: {
                    ...lodash.cloneDeep(initState.tableList),
                    loading: false,
                    error: action.error,
                }
            }
        case ACTIONS.GET_REPORT_CONFIG_SUCCESS:
            return {
                ...state,
                columns: action.data.columns,
                filters: action.data.filters
            }
        default:
            return state;
    }
};
